import { useTranslation } from 'react-i18next';
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from '@/components/ui/card';

interface Props {
  /** i18n key under `nav.*` — used as the page title. */
  titleKey: string;
  /** Short route identifier used as a subtitle. */
  slug: string;
}

export function PlaceholderPage({ titleKey, slug }: Props) {
  const { t } = useTranslation();
  return (
    <div className="space-y-4">
      <div>
        <h1 className="text-2xl font-semibold tracking-tight">{t(titleKey)}</h1>
        <p className="text-sm text-muted-foreground">/{slug}</p>
      </div>
      <Card>
        <CardHeader>
          <CardTitle>{t('common.comingSoon')}</CardTitle>
          <CardDescription>{t('common.placeholderHint')}</CardDescription>
        </CardHeader>
        <CardContent>
          <div className="grid grid-cols-1 gap-3 md:grid-cols-3">
            {[0, 1, 2].map((i) => (
              <div key={i} className="rounded-md border bg-muted/30 p-4">
                <div className="mb-2 h-3 w-1/3 rounded bg-muted" />
                <div className="h-6 w-2/3 rounded bg-muted" />
              </div>
            ))}
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
